import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";

function ResellerFilter(props) {
  return (
    <AsynchronousAutocomplete
      async={{
        url: "core/subsReseller/search?fields=id as value, description as label&per_page=10",
        searchField: "description",
      }}
      onChange={(e, option) => {
        if (option) {
          props.setFilter("subs_reseller_id", {
            field: "subs_reseller_id",
            operator: "=",
            value: option.value,
            label: option.label,
          });
        } else {
          props.setFilter("subs_reseller_id", null);
        }
      }}
      placeholder={getTranslation("Filter on reseller")}
      value={props.subs_reseller_id}
    />
  );
}

const mapStateToProps = (state) => ({ subs_reseller_id: state.filtersV2.subs_reseller_id });

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({ type: actions.SET_FILTER, payload: { key, filter } });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ResellerFilter);
